import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import plus_img from "../assets/icons/cross.svg";
import "./FAQ.css";
import GlassyButton from "./GlassyButton";

export const faqData = [
    {
        q: "Как проходит обмен?",
        a: "Вы связываетесь с нами в Telegram, мы фиксируем курс и сумму, после чего встречаемся в офисе и проводим сделку."
    },
    {
        q: "Где находится офис?",
        a: "Наш офис находится в Перми по адресу: ул. Луначарского, 90."
    },
    {
        q: "Какую криптовалюту меняете?",
        a: "Меняем USDT, Bitcoin, Ethereum и любые альткоины. Поддерживаем весь рынок криптовалют."
    },
    {
        q: "Какие суммы меняете?",
        a: "Мы работаем как с небольшими суммами, так и с крупными. Лимиты уточняйте в диалоге с оператором."
    },
    {
        q: "Есть ли комиссии?",
        a: "Никаких скрытых комиссий. Вы получаете обмен по курсу, который был заранее согласован с оператором."
    },
    {
        q: "Долго ли проходит обмен?",
        a: "Обычно встреча в офисе занимает не более 10–15 минут."
    }
];


function FAQItem({ q, a, isOpen, onClick }) {

    const contentRef = useRef(null);
    const [contentHeight, setContentHeight] = useState(0);

    useEffect(() => {
        if (contentRef.current) {
            setContentHeight(contentRef.current.scrollHeight);
        }
    }, [a, isOpen]);

    return (
        <div className="faq-item" onClick={onClick}>
            <h4 className="faq-question">
                <span>{q}</span>
                <motion.img
                    style={{marginBottom: '7px'}}
                    src={plus_img}
                    alt="toggle"
                    width={20}
                    height={20}
                    animate={{ rotate: isOpen ? 45 : 0 }}
                    transition={{ duration: 0.25 }}
                />
            </h4>

            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        className="faq-answer-wrapper"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: contentHeight, opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        style={{ overflow: "hidden" }}
                    >
                        <div ref={contentRef} className="faq-answer-content">
                            <p>{a}</p>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (i) => {
        setOpenIndex(openIndex === i ? null : i);
    };

    const handleClick = () => {
        const username = "obmenvpermi";
        const url = `https://t.me/${username}`;

        window.location.href = url;

        if (window.Telegram?.WebApp?.openTelegramLink) {
            window.Telegram.WebApp.openTelegramLink(url);
        }
    };

    return (
        <div className="card faq-wrapper">

            <h2 className={'uppercase'} style={{marginTop: '2px', marginBottom: '-2px'}}>
                Частые вопросы
            </h2>

            <div className="faq-list">
                {faqData.map((item, i) => (
                    <FAQItem
                        key={i}
                        q={item.q}
                        a={item.a}
                        isOpen={openIndex === i}
                        onClick={() => toggle(i)}
                    />
                ))}
            </div>

            <button onClick={() => handleClick()} className={'btn white-gradient'}>
                Задать Вопрос
            </button>

        </div>
    );
}
